import { MultiStepSignupPage } from "./multi-step-signup.page";

export const OnboardingPage = MultiStepSignupPage;
